"use client"

import { useEffect } from "react"
import { useTheme } from "next-themes"

/**
 * The auth pages open in dark mode by default. Only applied when the visitor
 * has no preference of their own yet (next-themes reports "system"); once they
 * use the switcher their choice is stored and kept.
 */
export function AuthThemeDefault() {
  const { theme, setTheme } = useTheme()

  useEffect(() => {
    if (theme === "system") setTheme("dark")
  }, [theme, setTheme])

  return null
}
